import { Injectable } from '@angular/core';
import { BodyOutputType, ToasterService, Toast } from 'angular2-toaster';
import { HttpErrorHandlerService } from './http-error-handler.service';

@Injectable()
export class AppToasterService extends ToasterService {

  constructor(private httpErrorHandler: HttpErrorHandlerService) {
    super();
  }

  pop(type?: string, title?: string, body?: any): Toast {
    const resolved = this.httpErrorHandler.resolveToast(type, title, body);
    if (resolved.useTrustedHtml) {
      const toast: Toast = {
        type: resolved.type,
        title: resolved.title,
        body: resolved.body,
        bodyOutputType: BodyOutputType.TrustedHtml,
      };
      return super.pop(toast);
    }
    return super.pop(resolved.type, resolved.title, resolved.body);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src259009759/src/src/app/shared/services/app-toaster.service.ts